import { jsx as B } from "react/jsx-runtime";
import y, { useState as v, useMemo as x, isValidElement as E } from "react";
import { makeClassesByStyles as M } from "../../utils/classes.js";
import b from "../../assets/bf502de3.gradient-border-wrapper.module.css";
const g = M(b), k = (e) => e.type === "button", S = ({
  children: e,
  color: a,
  hoverColor: s,
  borderRadius: n = "rounded-lg",
  isActive: i = !1,
  isDisabled: t = !1,
  isClickable: m = !1,
  fromTransparent: l = !1,
  size: u = "xs",
  className: d
}) => {
  const [f, r] = v(!1), p = x(() => y.Children.toArray(e).some((o) => E(o) && k(o)), []), c = g(
    "GradientBorderWrapper",
    {
      "--is-clickable": p || m,
      "--from-transparent": l,
      "--is-active": i,
      "--is-disabled": t
    },
    `--size-${u}`,
    `--${f && !t && s ? s : a}`,
    n,
    d
  );
  return /* @__PURE__ */ B(
    "div",
    {
      className: c,
      onMouseEnter: () => r(!0),
      onMouseLeave: () => r(!1),
      children: e
    }
  );
};
export {
  S as GradientBorderWrapper
};
